<ng-container *ngFor="let warehouse of filteredWarehouses">
  <app-warehouse-list-item [warehouse]="warehouse" [isCarrier]="isCarrier" (onRequestPermission)="onRequestPermission.emit($event)"></app-warehouse-list-item>
</ng-container>

<p *ngIf="filteredWarehouses?.length === 0" i18n>No warehouses.</p>
